export default {
  discord: {
    blurple: '#7289DA',
    greyple: '#99AAB5',
    darkButNotBlack: '#2C2F33',
    white: '#f6f6f7',
    red: '#f04747',
    green: '#43b581',
    yellow: 'rgb(250, 166, 26)',
    notQuiteblack: '#23272A',
    text: '#b9bbbe',
    subtext: '#72767d',
    offwhite: '#dcddde'
  }
}
